export const BOOK_SLOT_PROMPT_DISPLAYED_DESC = 'Book a slot notification shown';
export const BOOK_SLOT_PROMPT_CONFIRMED_DESC = 'Book a slot notification - link clicked';
